import { useContext, useMemo } from 'react';
import { useQuery } from '@tanstack/react-query';

import { UserContext } from "~/components/providers/UserProvider";
import type { PromoCarouselLocation } from '~/domains/promotions/types';
import { FEATURE } from '~/common/enums/feature.enum';
import { useIsFeatureEnabled } from '~/hooks/useIsFeatureEnabled';

import { getMissions } from '../services/missions.api';
import { MissionsQueryKeys } from '../constants/query';
import { type  MissionAssignment, MissionStatus } from '../types/missions.types';


export const useGetMissionsData = (
  enabled: boolean,
  location?: PromoCarouselLocation,
  status = MissionStatus.STARTED,
) => {
  const { user } = useContext(UserContext);
  const isMissionsEnabled = useIsFeatureEnabled(FEATURE.ENABLE_MISSIONS);

  // eslint-disable-next-line local-rules/require-query-stale-time
  const { data, isFetching, isError } = useQuery({
    queryKey: MissionsQueryKeys.MISSIONS({ status, location }),
    queryFn: () => getMissions({ status, location }),
    enabled: isMissionsEnabled && !!user && enabled,
  });

  const items: MissionAssignment[] = data?.data ?? [];

  const totalCount = useMemo(() => data?.total ?? 0, [items]);

  return {
    items,
    totalCount,
    isLoading: isFetching,
    isError,
  };
};
